var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCommentNotResolved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn-comment-not-resolved") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-comment-not-resolved",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,20 C4.48625,20 0,15.51375 0,10 C0,4.48625 4.48625,0 10,0 C15.51375,0 20,4.48625 20,10 C20,15.51375 15.51375,20 10,20 Z M10,1.25 C5.175,1.25 1.25,5.175 1.25,10 C1.25,14.825 5.175,18.75 10,18.75 C14.825,18.75 18.75,14.825 18.75,10 C18.75,5.175 14.825,1.25 10,1.25 Z",
    id: "Shape",
    fill: "#BAC0CB",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCommentNotResolved);
export default __webpack_public_path__ + "static/media/icn-comment-not-resolved.3e7e669d8ec4a275ca4f0f3fd7619d57.svg";
export { ForwardRef as ReactComponent };